// extracted by mini-css-extract-plugin
module.exports = {"invisible":"FavoriteStar__invisible--lO","starred":"FavoriteStar__starred--da"};